import {useState} from 'react';
import {useLocation} from 'react-router-dom';
import {useAuth} from '../authContext';
import {photoAccessScope} from './sessionStore';
import type {PhotoContext} from './contracts';

const storageKey='sonata_photo_filter_disclosures_v1';
type Saved={scope:string;entries:[string,boolean][]};
function read(scope:string):Saved{
 try{const saved=JSON.parse(sessionStorage.getItem(storageKey)||'null');
  if(saved?.scope===scope&&Array.isArray(saved.entries))return {scope,entries:saved.entries.filter((entry:unknown)=>Array.isArray(entry)&&typeof entry[0]==='string'&&typeof entry[1]==='boolean').slice(-32)};
 }catch{/* Storage may be unavailable; local interaction still works. */}
 return {scope,entries:[]};
}
/** Presentation state only: retain layout on photo return/reload, never query data. */
export function usePhotoFilterDisclosure(context?:PhotoContext){
 const {user,privileges}=useAuth(),location=useLocation(),scope=photoAccessScope(user,privileges);
 // Camera/Place filter values must not reset the panel while someone edits it.
 const entry=JSON.stringify([location.pathname,context?.kind,context?.farmId]);
 const key=scope+entry,load=()=>read(scope).entries.find(([id])=>id===entry)?.[1]||false;
 const [state,setState]=useState(()=>({key,open:load()}));
 const open=state.key===key?state.open:load();
 const toggle=()=>{
  const next=!open;setState({key,open:next});
  try{const saved=read(scope);saved.entries=[...saved.entries.filter(([id])=>id!==entry),[entry,next] as [string,boolean]].slice(-32);sessionStorage.setItem(storageKey,JSON.stringify(saved));}catch{/* Keep the in-memory state. */}
 };
 return {open,toggle};
}
